export interface SsoOidcDto {
    title: string;
    message: string;
    integrationName: string;
    integrationHandle: string;
    protocol: SSOProtocol;
}
export enum SSOProtocol {
    OPENID_CONNECT = 'openid_connect',
    OPENID_CONNECT_CUSTOM = 'openid_connect_custom',
    SAML = 'saml',
}
